import { Component, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { LoadingComponent } from '../../objects/loading/loading.component';
import { InfoComponent } from '../../objects/info/info/info.component';
import { AFP } from 'src/app/Models/planilla/afp';
import { DataService } from 'src/app/Service/data.service';

@Component({
  selector: 'app-afp-empresa',
  templateUrl: './afp-empresa.component.html',
  styleUrls: ['./afp-empresa.component.css']
})
export class AfpEmpresaComponent implements OnInit {

  @ViewChild(LoadingComponent, null) loading: LoadingComponent;
  @ViewChild(InfoComponent, null) info: InfoComponent;

  public search    = '';
  public page: any;
  public total     = 0;
  public items: AFP[] = [];
  public nuevo: AFP   = new AFP();
  public agregando    = false;
  private _backup: {[id: number]: any} = {};

  constructor(private data: DataService, private title: Title) {}

  ngOnInit() {
    this.title.setTitle('AFP / ONP | Sistema');
    this.GetData();
  }

  GetData() {
    this.loading.show('Cargando...');
    this.items = [];
    const req = this.search
      ? this.data.GetFromValue(this.data.api.afp, 'nombre__icontains', this.search)
      : this.data.GetSimple(this.data.api.afp);
    req.subscribe(
      r => { this.loading.hide(); this.items = r; this.total = r.length; },
      e => { this.loading.hide(); this.info.error(e, () => {}); }
    );
  }

  ShowNew()   { this.nuevo = new AFP(); this.agregando = true; }
  CancelNew() { this.agregando = false; this.nuevo = new AFP(); }
  formNewValid(): boolean { return !!(this.nuevo.nombre && this.nuevo.porcentaje !== undefined && this.nuevo.porcentaje !== null); }

  SaveNew() {
    this.loading.show('Registrando...');
    this.data.Post(this.data.api.afp, this.nuevo).subscribe(
      r => { this.loading.hide(); this.agregando = false; this.nuevo = new AFP(); this.GetData(); },
      e => { this.loading.hide(); this.info.error(e, () => {}); }
    );
  }

  StartEdit(item: AFP)  { this._backup[item.idafp] = { ...item }; item.editando = true; }
  CancelEdit(item: AFP) { Object.assign(item, this._backup[item.idafp]); item.editando = false; }

  SaveEdit(item: AFP) {
    this.loading.show('Actualizando...');
    this.data.Put(this.data.api.afp, `${item.idafp}`, item).subscribe(
      r => { this.loading.hide(); item.editando = false; delete this._backup[item.idafp]; },
      e => { this.loading.hide(); this.info.error(e, () => {}); }
    );
  }

  ShowDelete(item: AFP) {
    this.info.show(`¿Deseas eliminar "${item.nombre}"?`, 1, null,
      { cancelText: 'No, Cancelar', successText: 'Sí, Eliminar', isCancel: true },
      () => this.Delete(item), () => { this.info.hide(); }, 20);
  }

  Delete(item: AFP) {
    this.loading.show('Eliminando...');
    this.data.Delete(this.data.api.afp, `${item.idafp}`).subscribe(
      r => { this.loading.hide(); this.info.show(r.message, 2, null, null, () => { this.info.hide(); this.GetData(); }); },
      e => { this.loading.hide(); this.info.error(e, () => this.info.hide()); }
    );
  }
}
